export const tournamentSeriesListing: TableModule = {
    name: "tournamentSeriesListing",
    route: "spa.sportsManagement.tournamentSeries",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
        }, {
            name: "tournaments",
        }
    ],
    filters: [],
    quickFilters: [],
    tools: []
}